import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var sidebarComponentName = 'QuantumSidebar';
export function getSidebarUtilityClass(slot) {
    return generateUtilityClass(sidebarComponentName, slot);
}
export var sidebarClasses = generateUtilityClasses(sidebarComponentName, [
    'root',
    'paper',
    'paperHovered',
    'paperCollapsed',
]);
